import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { PhotoAlbum } from 'react-photo-album';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebase';

const GalleryPage = () => {
  const location = useLocation();
  const [index, setIndex] = useState(-1);
  const [selectedArtist, setSelectedArtist] = useState('All');
  const [artists, setArtists] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (location.state?.artist) {
      setSelectedArtist(location.state.artist);
    }
  }, [location.state]);

  const loadData = async () => {
    try {
      const artistsSnapshot = await getDocs(collection(db, 'artists'));
      const artistsData = artistsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setArtists(artistsData);

      const gallerySnapshot = await getDocs(collection(db, 'gallery'));
      const galleryData = gallerySnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          src: data.original,
          original: data.original,
          width: data.width || 800,
          height: data.height || 600,
          artist: data.artist
        };
      });
      setGalleryImages(galleryData);
    } catch (error) {
      console.error('Error loading gallery data:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredImages = selectedArtist === 'All' 
    ? galleryImages 
    : galleryImages.filter(img => img.artist === selectedArtist);

  const slides = filteredImages.map(({ original, width, height }) => ({
    src: original,
    width,
    height,
  }));

  if (loading) {
    return (
      <section className='bg-[#f9f9f9] section'>
        <div className="h-20 md:h-10"></div>
        <div className="container mx-auto text-center py-12">
          <p>Loading gallery...</p>
        </div>
      </section>
    );
  }

  return (
    <section className='bg-[#f9f9f9] section'>
      <div className="h-20 md:h-10"></div>
      <div className="container mx-auto text-center">
        <h2 className="text-3xl font-bold mb-8">Our Gallery</h2>
        
        <div className="flex justify-center space-x-4 mb-10 flex-wrap gap-2">
          <button
            className={`btn ${selectedArtist === 'All' ? 'btn-dark' : 'btn-light'} mb-2`}
            onClick={() => setSelectedArtist('All')}
          >
            All
          </button>
          {artists.map((artist) => (
            <button
              key={artist.id}
              className={`btn ${selectedArtist === artist.name ? 'btn-dark' : 'btn-light'} mb-2`}
              onClick={() => setSelectedArtist(artist.name)}
            >
              {artist.name}
            </button>
          ))}
        </div>

        {filteredImages.length > 0 ? (
          <>
            <PhotoAlbum
              onClick={(event, photo, photoIndex) => setIndex(photoIndex)}
              layout="rows"
              photos={filteredImages}
            />
            
            <Lightbox
              slides={slides}
              open={index >= 0}
              index={index}
              close={() => setIndex(-1)}
              styles={{ container: { backgroundColor: 'rgba(0,0,0,.9)' } }}
            />
          </>
        ) : (
          <div className="py-12 bg-white rounded-lg shadow-sm">
            <p className="text-gray-600">
              {selectedArtist === 'All' 
                ? 'No images in the gallery yet.' 
                : `No images by ${selectedArtist} yet.`}
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default GalleryPage;